const action = {
  GET: "get",
  PUT: "put",
  DELETE: "delete",
  POST: "post",
};
export default action;
